import Box from '@mui/material/Box';
import { BannerFrameSVGProps } from 'src/pages/video-banner-preview';

export function BottomMiddle({ height, width }: BannerFrameSVGProps) {
  const viewHeight = height;
  const viewWidth = width;
  const svg = (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewWidth} ${viewHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`M0 4H${width}`}
        stroke="url(#paint0_linear_14030_182092)"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14030_182092"
          x1="217.871"
          y1="-592"
          x2="217.871"
          y2="93.0098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0366e9" />
          <stop offset="1" stopColor="#0366e9" />
        </linearGradient>
      </defs>
    </svg>
  );
  return <Box>{svg}</Box>;
}
